import type { Master, MasterCycle } from '../api/monitor';

/** `44.264.331/0001-04`; o banco guarda só os 14 dígitos. */
export function formatCnpj(value: string): string {
  const digits = value.replace(/\D/g, '');

  if (digits.length !== 14) return value;

  return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}/${digits.slice(8, 12)}-${digits.slice(12)}`;
}

/** O dia em que o ciclo abre: o seguinte ao fechamento (31 → 1). */
export function cycleStartDay(billEndDay: number): number {
  return billEndDay >= 31 ? 1 : billEndDay + 1;
}

/** `Claro: vira dia 21` — o ciclo como a lista o mostra. */
export function cycleLabel(cycle: MasterCycle): string {
  return `${cycle.operatorName}: vira dia ${cycleStartDay(cycle.billEndDay)}`;
}

/** Os ciclos da master numa linha; vazio vira o aviso de que a rotina usa o padrão. */
export function cyclesSummary(master: Master): string {
  return master.cycles.length
    ? master.cycles.map(cycleLabel).join(' · ')
    : 'Sem ciclo cadastrado — a rotina usa a janela padrão';
}

const SOURCE_LABELS: Record<string, string> = {
  sgc: 'SGC',
  'sicop-local': 'Cadastrada no SICOP',
  legacy_hawk: 'Legado',
};

/** De onde a master veio, em português. */
export function sourceLabel(source: string): string {
  return SOURCE_LABELS[source] ?? source;
}

/** A master vem do snapshot do SGC: nome, CNPJ, código e situação voltam ao do SGC. */
export function comesFromSgc(master: Pick<Master, 'source'>): boolean {
  return master.source === 'sgc';
}

/** Minúsculas e sem acento, para a busca achar "Goiania" em "Goiânia". */
function fold(text: string): string {
  return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
}

/** True quando a master casa com a busca da tela (nome, CNPJ ou código). */
export function masterMatches(master: Master, needle: string): boolean {
  const term = fold(needle.trim());
  if (!term) return true;

  const haystack = fold(
    [master.name, master.cnpj, formatCnpj(master.cnpj), master.code ?? ''].join(' ')
  );

  return haystack.includes(term);
}
